import React from 'react';
import { Badge } from '@zoopla-eng/zds/badges';
import { Box } from '@zoopla-eng/zds/box';

type StatusProps = {
    value: string;
};

export const Status: React.FC<StatusProps> = ({ value }) => {
    const getBadgeLevel = (value: string) => {
        if (value === 'Just added') {
            return 2;
        }

        return 3;
    };

    return value ? (
        <Box pb="S300">
            <Badge level={getBadgeLevel(value)} text={value} />
        </Box>
    ) : null;
};
